import { cva, type VariantProps } from 'class-variance-authority';

export const selectVariants = cva(
	'rounded-medium shadow-xs bg-background ring-offset-background [& > span]:line-clamp-1 flex w-full items-center justify-between border focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 data-[placeholder]:text-gray-500 data-[state="open"]:ring-4 data-[state="open"]:ring-opacity-15 data-[state="open"]:ring-offset-0',
	{
		variants: {
			size: {
				md: 'px-2xl py-lg gap-md text-md',
				sm: 'px-xl py-md gap-md text-sm',
			},
			hasError: {
				true: 'border-error-300 data-[state="open"]:ring-error-500 [&_svg]:fill-error-500',
				false:
					'border-gray-300 data-[state="open"]:ring-gray-400 [&_svg]:fill-gray-500',
			},
		},
		defaultVariants: {
			size: 'md',
		},
	},
);

export type SelectVariants = VariantProps<typeof selectVariants>;

export { default as Select } from './Select.vue';
export { default as SelectContent } from './SelectContent.vue';
export { default as SelectGroup } from './SelectGroup.vue';
export { default as SelectItem } from './SelectItem.vue';
export { default as SelectItemText } from './SelectItemText.vue';
export { default as SelectLabel } from './SelectLabel.vue';
export { default as SelectScrollDownButton } from './SelectScrollDownButton.vue';
export { default as SelectScrollUpButton } from './SelectScrollUpButton.vue';
export { default as SelectSeparator } from './SelectSeparator.vue';
export { default as SelectTrigger } from './SelectTrigger.vue';
export { default as SelectValue } from './SelectValue.vue';
